"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ConnectedNav = exports.mapDispatchToProps = exports.getSelectedKey = exports.RoutedNav = void 0;

var _startsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/starts-with"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/reduce"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var _CollapsibleNav = require("@uifabric/portal-ux/lib/CollapsibleNav");

var React = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _Nav = require("../../Nav/models/Nav");

var _isUrlAbsolute = require("../../pattern-checkers/isUrlAbsolute");

var _createAction = require("../../redux/createAction");

var _overrideSettings = require("../../shared/override-settings/overrideSettings");

/**
 * The RoutedNav represents a nav that support history based navigation and redux for state management.
 */
var RoutedNav = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(RoutedNav, _React$Component);

  var _super = (0, _createSuper2.default)(RoutedNav);

  function RoutedNav() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, RoutedNav);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));

    _this._onLinkClick = function (ev, item) {
      if (ev === undefined || item === undefined || (0, _isUrlAbsolute.isUrlAbsolute)(item.url)) {
        return;
      }

      ev.preventDefault();
      addTelemetry(item.key); // Convert to router aware navigation, could also use push from react-router-redux

      _this.props.history.push(item.url);
    };

    return _this;
  }

  (0, _createClass2.default)(RoutedNav, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CollapsibleNav.CollapsibleNav, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
        onLinkClick: this._onLinkClick
      }));
    }
  }]);
  return RoutedNav;
}(React.Component);

exports.RoutedNav = RoutedNav;

var addTelemetry = function addTelemetry(linkKey) {
  var telemetryEmitter = (0, _overrideSettings.getOverrideSetting)('telemetryImplementation');

  if (telemetryEmitter) {
    var _telemetryEmitter$log;

    (_telemetryEmitter$log = telemetryEmitter.log) === null || _telemetryEmitter$log === void 0 ? void 0 : _telemetryEmitter$log.call(telemetryEmitter, 'nav/link/clicked', {
      link: linkKey
    });
  }
};
/**
 * Gets the key of the link that matches a location from the groups of links
 * @param groups The url nav groups
 * @param location The router location
 */


var getSelectedKey = function getSelectedKey(groups, location) {
  var pathname = addSlashEnding(location.pathname);
  var selectedKey = (0, _reduce.default)(groups).call(groups, function (linkKey, linkGroup) {
    var _context2;

    if (linkKey) {
      return linkKey;
    }

    return (0, _reduce.default)(_context2 = linkGroup.links).call(_context2, function (foundLinkKey, link) {
      if (foundLinkKey) {
        return foundLinkKey;
      }

      if (link.exact) {
        if (link.url !== undefined && link.url !== '' && pathname === addSlashEnding(link.url)) {
          return link.key;
        }
      } else {
        if (link.url !== undefined && link.url !== '' && (0, _startsWith.default)(pathname).call(pathname, addSlashEnding(link.url))) {
          return link.key;
        }
      }

      if (link.alias !== undefined && link.alias !== '' && pathname === addSlashEnding(link.alias)) {
        return link.key;
      } // If the link has an alternate url check that


      if (link.alias !== undefined && link.alias !== '' && link.alias !== '/' && (0, _startsWith.default)(pathname).call(pathname, addSlashEnding(link.alias))) {
        return link.key;
      }

      return foundLinkKey;
    }, linkKey);
  }, '');
  return selectedKey;
};

exports.getSelectedKey = getSelectedKey;

var addSlashEnding = function addSlashEnding(str) {
  if (str[str.length - 1] === '/') {
    return str;
  }

  return str + '/';
};

var mapStateToProps = function mapStateToProps(state, props) {
  var location = state.router.location;
  var selectedKey = '';
  var groups = props.groups;

  if (location !== null && groups !== null) {
    // Makes the nav component aware of router's location
    selectedKey = getSelectedKey(groups, location);
  }

  return (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), state.nav), {}, {
    selectedKey: selectedKey
  });
};
/**
 * Maps the dispatch actions to the props for the StandardAppBar control.
 * @param dispatch Dispatches actions to the store
 * @returns The mapped actions that along with the mapped properties
 * becomes the props (IStandardAppBarProps) for the StandardAppBar control
 */


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    collapseNav: (0, _createAction.createAction)(_Nav.NavActions.collapseNav, dispatch)
  };
};
/**
 * A redux connected ConnectedNav control.
 */


exports.mapDispatchToProps = mapDispatchToProps;
var ConnectedNav = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RoutedNav);
exports.ConnectedNav = ConnectedNav;